import connection from "../../utils/connection";

const resetPassword = async ({ password, repeatPassword, hash }) => {
    let response = {};
    try {
        const responseGet = await connection({
            method: 'POST',
            url: `/usuarios/auth/restablecer-password`,
            body: { password, repeatPassword, hash },
        });
        response.data = responseGet;
    } catch (error) {
        console.error("catch service", error);
        response = error.response;
    }

    return response;
};

export default resetPassword;
